import {
  CreateAlarmMutation,
  CreateAlertMutation,
  CreateEventMutation,
  FeatureDomain,
} from '@akin-home/amplify';
import { showSuccessToast } from '@akin-home/toast/native';
import { sendBackgroundMessage } from '../../chat/functions';
import { postCreateRecordLogEvent } from '../../logging/functions/postCreateRecordLogEvent';
import { getCurrentUserID } from '../../users/functions';

type Params = CreateEventMutation | CreateAlarmMutation | CreateAlertMutation;

export const afterCreateCalendarItem = (params: Params) => {
  const { trigger, type, context } = getInfo(params);

  sendBackgroundMessage(trigger, { context });

  postCreateRecordLogEvent({
    user_id: getCurrentUserID() as string,
    feature_domain: FeatureDomain.CALENDAR,
    data: {
      model: type || 'Calendar Item',
    },
  });

  showSuccessToast({
    text1: 'Success!',
    text2: 'Event Created',
  });
};

const getInfo = (params: Params) => {
  if (isCreateEvent(params)) {
    return {
      trigger: 'event_created',
      type: params.createEvent?.type,
      context: {
        event: {
          ...params.createEvent,
        },
      },
    };
  } else if (isCreateAlert(params)) {
    return {
      trigger: 'alert_created',
      type: params.createAlert?.type,
      context: {
        alert: {
          ...params.createAlert,
        },
      },
    };
  } else {
    return {
      trigger: 'alarm_created',
      type: params.createAlarm?.type,
      context: {
        alarm: {
          ...params.createAlarm,
        },
      },
    };
  }
};

const isCreateEvent = (params: Params): params is CreateEventMutation =>
  'createEvent' in params;

// const isCreateAlarm = (params: Params): params is CreateAlarmMutation =>
//   'createAlarm' in params;

const isCreateAlert = (params: Params): params is CreateAlertMutation =>
  'createAlert' in params;
